import React from "react";
import { Link } from "react-router-dom";
import "./LandingPage.css";
import { ROUTES } from "../config/constants";
import { FEATURES } from "./LandingPage.data";
import { DocumentIcon, EmbedIcon, AnalyticsIcon } from "../components/NavIcons";

// Presentation map: iconKey (semantic) → display value.
// Exported so tests can verify every FEATURES iconKey has a mapping here.
export const FEATURE_ICONS = {
  knowledge: <DocumentIcon />,
  embed: <EmbedIcon />,
  analytics: <AnalyticsIcon />,
};

export function LandingPage() {
  return (
    <div className="landing-container">
      <header className="landing-header">
        <div className="landing-nav">
          <span className="landing-logo">Kwibl</span>
          <div className="landing-nav-links">
            <Link to={ROUTES.LOGIN} className="nav-link">
              Sign In
            </Link>
            <Link to={ROUTES.REGISTER} className="btn-nav-cta">
              Get Started
            </Link>
          </div>
        </div>
      </header>

      <main>
        <section className="landing-hero">
          <div className="hero-content">
            <h1>Add AI chat to your website in minutes</h1>
            <p className="hero-subtitle">
              Build, train, and embed a custom AI chatbot — no coding required.
              Connect your knowledge base and let Kwibl handle the rest.
            </p>
            <div className="hero-actions">
              <Link
                to={ROUTES.REGISTER}
                className="landing-btn-lg landing-btn-primary-lg"
              >
                Get Started Free
              </Link>
              <Link
                to={ROUTES.LOGIN}
                className="landing-btn-lg landing-btn-secondary-lg"
              >
                Sign In
              </Link>
            </div>
          </div>
        </section>

        <section className="landing-features">
          <div className="features-grid">
            {FEATURES.map((feature) => (
              <div className="feature-card" key={feature.title}>
                <div className="feature-icon">
                  {FEATURE_ICONS[feature.iconKey]}
                </div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </section>
      </main>

      <footer className="landing-footer">
        <p>&copy; {new Date().getFullYear()} Kwibl. All rights reserved.</p>
        <div className="footer-links">
          <Link to={ROUTES.LOGIN}>Sign In</Link>
          <Link to={ROUTES.REGISTER}>Register</Link>
        </div>
      </footer>
    </div>
  );
}
